import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "opModal" };
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("div", { class: "text-red" }, " Ricerca anagrafiche ", -1);
const _hoisted_3 = { class: "row" };
const _hoisted_4 = { class: "col-md-6" };
const _hoisted_5 = { class: "form-group" };
const _hoisted_6 = /*#__PURE__*/ _createElementVNode("label", null, "Nome", -1);
const _hoisted_7 = { class: "form-group" };
const _hoisted_8 = /*#__PURE__*/ _createElementVNode("label", null, "Cognome", -1);
const _hoisted_9 = { class: "col-md-6" };
const _hoisted_10 = { class: "form-group" };
const _hoisted_11 = /*#__PURE__*/ _createElementVNode("label", null, "Username", -1);
const _hoisted_12 = { class: "form-group" };
const _hoisted_13 = /*#__PURE__*/ _createElementVNode("label", null, "Email", -1);
const _hoisted_14 = /*#__PURE__*/ _createElementVNode("hr", null, null, -1);
const _hoisted_15 = { class: "max-h-400" };
const _hoisted_16 = { class: "table" };
const _hoisted_17 = /*#__PURE__*/ _createElementVNode("thead", null, [
    /*#__PURE__*/ _createElementVNode("tr", null, [
        /*#__PURE__*/ _createElementVNode("td", null, "ID"),
        /*#__PURE__*/ _createElementVNode("td", null, "Nome"),
        /*#__PURE__*/ _createElementVNode("td", null, "Cognome"),
        /*#__PURE__*/ _createElementVNode("td", null, "Username"),
        /*#__PURE__*/ _createElementVNode("td", null, "Email")
    ])
], -1);
const _hoisted_18 = { key: 0 };
const _hoisted_19 = ["onClick"];
const _hoisted_20 = { class: "d-flex justify-content-center mt-2" };
const _hoisted_21 = ["disabled"];
const _hoisted_22 = ["onClick"];
const _hoisted_23 = {
    type: "button",
    class: "btn btn-sm btn-link selected"
};
const _hoisted_24 = ["onClick"];
const _hoisted_25 = ["disabled"];
const _hoisted_26 = { class: "text-end mt-4" };
const _hoisted_27 = ["disabled"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                    _hoisted_6,
                    _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "form-control",
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.nome) = $event))
                    }, null, 512), [
                        [_vModelText, _ctx.nome]
                    ])
                ]),
                _createElementVNode("div", _hoisted_7, [
                    _hoisted_8,
                    _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "form-control",
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.cognome) = $event))
                    }, null, 512), [
                        [_vModelText, _ctx.cognome]
                    ])
                ])
            ]),
            _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                    _hoisted_11,
                    _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "form-control",
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.username) = $event))
                    }, null, 512), [
                        [_vModelText, _ctx.username]
                    ])
                ]),
                _createElementVNode("div", _hoisted_12, [
                    _hoisted_13,
                    _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "form-control",
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.email) = $event))
                    }, null, 512), [
                        [_vModelText, _ctx.email]
                    ])
                ])
            ])
        ]),
        _hoisted_14,
        _createElementVNode("div", _hoisted_15, [
            _createElementVNode("table", _hoisted_16, [
                _hoisted_17,
                _createElementVNode("tbody", null, [
                    (_ctx.list.data.length == 0)
                        ? (_openBlock(), _createElementBlock("tr", _hoisted_18, " Nessuna riga da mostrare "))
                        : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list.data, (item, i) => {
                        return (_openBlock(), _createElementBlock("tr", {
                            class: _normalizeClass(["pointer", { active: _ctx.selectedItem == item }]),
                            key: i,
                            onClick: ($event) => (_ctx.selectedItem = item)
                        }, [
                            _createElementVNode("td", null, _toDisplayString(item.idNumber), 1),
                            _createElementVNode("td", null, _toDisplayString(item.nome), 1),
                            _createElementVNode("td", null, _toDisplayString(item.cognome), 1),
                            _createElementVNode("td", null, _toDisplayString(item.username), 1),
                            _createElementVNode("td", null, _toDisplayString(item.email), 1)
                        ], 10, _hoisted_19));
                    }), 128))
                ])
            ])
        ]),
        _createElementVNode("div", _hoisted_20, [
            _createElementVNode("button", {
                type: "button",
                class: "btn btn-sm btn-link me-2",
                disabled: _ctx.page == 1,
                onClick: _cache[4] || (_cache[4] =
                    //@ts-ignore
                    (...args) => (_ctx.prev && _ctx.prev(...args)))
            }, "Prec.", 8, _hoisted_21),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.prevPages, (p) => {
                return (_openBlock(), _createElementBlock("button", {
                    type: "button",
                    class: "btn btn-sm btn-link me-2",
                    onClick: ($event) => (_ctx.setPage(p))
                }, _toDisplayString(p), 9, _hoisted_22));
            }), 256)),
            _createElementVNode("button", _hoisted_23, _toDisplayString(_ctx.page), 1),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.nextPages, (p) => {
                return (_openBlock(), _createElementBlock("button", {
                    type: "button",
                    class: "btn btn-sm btn-link ms-2",
                    onClick: ($event) => (_ctx.setPage(p))
                }, _toDisplayString(p), 9, _hoisted_24));
            }), 256)),
            _createElementVNode("button", {
                type: "button",
                class: "btn btn-sm btn-link ms-2",
                disabled: _ctx.totalPages <= _ctx.page,
                onClick: _cache[5] || (_cache[5] =
                    //@ts-ignore
                    (...args) => (_ctx.next && _ctx.next(...args)))
            }, "Succ.", 8, _hoisted_25)
        ]),
        _createElementVNode("div", _hoisted_26, [
            _createElementVNode("button", {
                type: "button",
                class: "btn btn-primary",
                disabled: !_ctx.selectedItem,
                onClick: _cache[6] || (_cache[6] = ($event) => (_ctx.ok()))
            }, "Seleziona", 8, _hoisted_27)
        ])
    ]));
}
